export default __webpack_public_path__ + "static/media/sampleCsv.5e9fdb68.svg";